import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Typography, Button, Dropdown, DropdownMenuItem} from 'views/components';
import {Translate} from 'views/module';

const Content = (props) => {
  const [newAutoCharge, setNewAutoCharge] = React.useState(false);
  const [isSaving, setIsSaving] = React.useState(false);

  const clientPaymentPlan = props.clientPaymentPlan;
  const updateClientAutoCharge = props.updateClientAutoCharge;
  const setViewMode = props.setViewMode;

  React.useEffect(() => {
    setNewAutoCharge(Boolean(clientPaymentPlan?.autoCharge));
  }, [clientPaymentPlan]);

  const onSave = () => {
    setIsSaving(true);
    const onSuccess = () => {
      setIsSaving(false);
      setViewMode();
    };
    updateClientAutoCharge(newAutoCharge, onSuccess);
  };

  return (
    <Stack
      direction={'column'}
      spacing={1}
      sx={{
        'display': 'flex',
      }}
    >
      <Box>
        <Typography
          sx={{
            fontSize: '10px',
          }}
        >
          <Translate
            expression='client.ClientDetail.Payment.PaymentPlan.AutopayTitle'
          />
        </Typography>
      </Box>
      <Box>
        <Dropdown
          value={newAutoCharge}
          onChange={setNewAutoCharge}
        >
          <DropdownMenuItem value={false}>
            <Translate expression='client.ClientDetail.Payment.PaymentPlan.Autopay.Options.false' />
          </DropdownMenuItem>
          <DropdownMenuItem value={true}>
            <Translate expression='client.ClientDetail.Payment.PaymentPlan.Autopay.Options.true' />
          </DropdownMenuItem>
        </Dropdown>
      </Box>
      <Stack
        direction={'row'}
        spacing={1}
        sx={{
        }}
      >
        <Button
          variant='outlined'
          onClick={setViewMode}
        >
          <Translate expression='generic.Cancel' />
        </Button>
        <Button
          loading={isSaving}
          onClick={onSave}
        >
          <Translate expression='generic.Save' />
        </Button>
      </Stack>
    </Stack>
  );
};

Content.propTypes = {
  clientPaymentPlan: PropTypes.object.isRequired,
  updateClientAutoCharge: PropTypes.func.isRequired,
  setViewMode: PropTypes.func.isRequired,
};
export default React.memo(Content);
